"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsLocationSettings_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsLocationSettings_Factory = /** @class */ (function () {
    function EFormsLocationSettings_Factory() {
    }
    EFormsLocationSettings_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AcceptingForms: model.AcceptingForms,
            BusinessName: model.BusinessName,
            DisplayName: model.DisplayName,
            InternalName: model.InternalName,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UpdatedBy: model.UpdatedBy,
            UpdatedByUserName: model.UpdatedByUserName,
        };
        return result;
    };
    EFormsLocationSettings_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AcceptingForms: model.AcceptingForms,
            BusinessName: model.BusinessName,
            DisplayName: model.DisplayName,
            InternalName: model.InternalName,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UpdatedBy: model.UpdatedBy,
            UpdatedByUserName: model.UpdatedByUserName,
        };
        return result;
    };
    return EFormsLocationSettings_Factory;
}());
exports.EFormsLocationSettings_Factory = EFormsLocationSettings_Factory;
